import { useAuth } from "@sal/authentication.react";

export default function getUsername(auth: ReturnType<typeof useAuth>) {
	const firstName = auth.user?.firstName ?? "";
	const lastName = auth.user?.lastName ?? "";
	return `${firstName} ${lastName}`;
}